/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-content[_ngcontent-%COMP%]{height:100%;position:relative}[_nghost-%COMP%], [_nghost-%COMP%]   .app[_ngcontent-%COMP%]{height:100%}.fixed-content[_ngcontent-%COMP%]{height:100%;position:absolute;width:100%}  .ui-grid-col-4{white-space:nowrap;width:200px}  .ui-grid-row{margin-bottom:6px}  .ui-dialog{overflow:visible}  .ui-dialog .ui-dialog-content{overflow:visible}  .ui-confirmdialog-message{white-space:pre-line}"];
export { styles as styles };
